import { render, staticRenderFns } from "./ItemImageAssociationIndex.vue?vue&type=template&id=46af7d51&"
import script from "./ItemImageAssociationIndex.vue?vue&type=script&lang=js&"
export * from "./ItemImageAssociationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports